<template>
  <div v-if="loaded" class="point_transfer_wrapper">
    <div
      class="point_transfer_block"
      @click="open = true"
      :class="[type + (isCharity ? '_charity' : '')]"
    >
      <div class="point_transfer_header">
        <h3 class="point_transfer_title">{{ texts.title }}</h3>
        <p class="point_transfer_description">{{ texts.subtitle }}</p>
      </div>
      <div class="point_transfer_bottom">
        <div class="point_transfer_info">
          <span class="point_transfer_points" v-if="!isCharity"
            >{{ transferPoints }}
            {{ transferPoints | pluralize("point,points,points") }}</span
          >
          <span class="point_transfer_time" v-if="!isCharity"
            >{{ texts.willExpire }}
          </span>
        </div>
        <span class="point_transfer_arrow"></span>
      </div>
    </div>

    <transition name="s_popup_transition">
      <div v-if="open" class="popup">
        <div
          class="popup-inner popup-inner-transfer popup-inner-gift-quest"
          v-on-clickaway="
            () => {
              open = popupClickawayLock ? open : false;
            }
          "
        >
          <a href="#" class="close" @click.prevent="open = false"></a>
          <span class="popup-inner-transfer_title">{{ texts.popupTitle }}</span>
          <span class="popup-inner-transfer_subtitle">{{
            texts.popupSubtitle
          }}</span>
          <div
            class="popup-inner-transfer_input_wrapper type_error"
            v-if="!isCharity"
          >
            <input
              class="popup-inner-transfer_input"
              type="email"
              :placeholder="texts.emailInput"
              v-model="email"
              @input="onInput"
            />
            <div
              v-if="validationStatus === 'error'"
              class="popup-inner-transfer_input_error_message"
            >
              <div class="popup-inner-transfer_input_error_message_popup">
                {{ texts.notFound }}
              </div>
            </div>
            <div
              v-if="validationStatus === 'ok'"
              class="popup-inner-transfer_input_success_message"
            />
          </div>

          <div v-if="isCharity">
            <div class="tabs">
              <div
                class="tabs_tab"
                :class="{ active: tab == 'default' }"
                @click="tab = 'default'"
              >
                Send once
              </div>
              <div
                class="tabs_tab"
                :class="{ active: tab == 'quarterly' }"
                @click="tab = 'quarterly'"
              >
                Every quarter
              </div>
            </div>
            <div v-if="tab == 'default'">
              <div
                v-if="texts.charities"
                class="popup-inner-transfer_input type_select"
              >
                <select v-model="comment">
                  <option disabled selected value="">
                    {{ texts.charities.default }}
                  </option>
                  <option
                    v-for="(option, index) in filteredCharities"
                    :key="index"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <input
                type="number"
                v-model="points"
                class="popup-inner-transfer_input"
                :placeholder="
                  texts.pointsInput +
                  ' (' +
                  transferPoints +
                  ' points available)'
                "
              />
              <button
                :disabled="!valid"
                @click="transfer"
                class="popup-inner-transfer_button"
              >
                {{ texts.popupButton }}
              </button>
            </div>

            <div v-else-if="tab == 'quarterly'">
              <div
                v-if="texts.charities"
                class="popup-inner-transfer_input type_select"
              >
                <select v-model="quarterlyCharity">
                  <option selected value="">
                    {{ texts.charities.default_quarterly }}
                  </option>
                  <option
                    v-for="(option, index) in filteredCharities"
                    :key="index"
                    :value="option.text"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div
                class="popup-inner-transfer_info"
                v-html="texts.distribute_myself"
                v-if="!quarterlyCharity"
              ></div>
              <div
                class="popup-inner-transfer_info"
                v-html="texts.distribute_to_charity"
                v-else
              ></div>
              <button
                :disabled="loading"
                @click="quarterlySave"
                class="popup-inner-transfer_button"
              >
                {{ texts.popupButtonSave }}
              </button>
            </div>
          </div>

          <div v-else>
            <input
              type="number"
              v-model="points"
              class="popup-inner-transfer_input"
              :placeholder="
                texts.pointsInput + ' (' + transferPoints + ' points available)'
              "
            />
            <div
              v-if="texts.reason"
              class="popup-inner-transfer_input type_select"
            >
              <select v-model="reason">
                <option disabled selected value="">
                  {{ texts.reason.default }}
                </option>
                <option
                  v-for="(option, index) in texts.reason.options"
                  :key="index"
                >
                  {{ option }}
                </option>
              </select>
            </div>
            <input
              type="text"
              v-model="comment"
              class="popup-inner-transfer_input"
              placeholder="Reason for sharing"
              maxlength="255"
              v-if="!isCharity"
            />
            <button
              :disabled="!valid"
              @click="transfer"
              class="popup-inner-transfer_button"
            >
              {{ texts.popupButton }}
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="s_popup_transition">
      <div v-if="resultPopup" class="popup">
        <div
          class="popup-inner popup-inner-transfer popup-inner-gift-quest"
          v-on-clickaway="
            () => {
              resultPopup = resultPopupClickawayLock ? resultPopup : false;
            }
          "
        >
          <a href="#" class="close" @click.prevent="resultPopup = null"></a>
          <span class="popup-inner-transfer_title">{{
            texts.resultPopup[resultPopup].title
          }}</span>
          <span class="popup-inner-transfer_subtitle">{{
            texts.resultPopup[resultPopup].subtitle
          }}</span>
          <button
            class="popup-inner-transfer_button"
            @click="resultPopup = null"
          >
            {{ texts.resultPopup[resultPopup].button }}
          </button>
        </div>
      </div>
    </transition>

    <div></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CONFIG from "../../config";
import { directive as onClickaway } from "vue-clickaway2";

export default {
  name: "AppPointTransfer",
  data() {
    return {
      open: false,
      validationStatus: "none",
      email: "",
      points: null,
      comment: "",
      reason: "",
      userId: "",
      loading: false,
      popupClickawayLock: true,
      resultPopupClickawayLock: true,
      resultPopup: null,
      tab: "default",
      quarterlyCharity: "",
    };
  },
  props: {
    texts: Object,
    auth_hash: String,
    quest: Object,
    transferPoints: Number,
    type: String,
    isCharity: {
      type: Boolean,
      defalt: false,
    },
  },
  directives: {
    onClickaway,
  },
  mounted() {
    if (this.isCharity) {
      this.email = this.texts && this.texts.charityEmail;
      this.checkEmail();

      let foundTags =
        this.currentTags &&
        this.currentTags.find(
          (tag) =>
            this.texts.charities.options &&
            this.texts.charities.options
              .map((charity) => charity.text)
              .includes(tag.tag)
        );

      this.quarterlyCharity = foundTags && foundTags.tag;
    }
  },
  watch: {
    open(value) {
      let className = "lock-scroll";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
        setTimeout(() => {
          this.popupClickawayLock = false;
        }, 200);
      } else {
        document.documentElement.classList.remove(className);
        document.documentElement.scrollTop = -parseFloat(
          document.getElementsByTagName("body")[0].style.top.replace("px", "")
        );
        this.popupClickawayLock = true;
      }
    },
    resultPopup(value) {
      let className = "lock-scroll";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
        setTimeout(() => {
          this.resultPopupClickawayLock = false;
        }, 200);
      } else {
        document.documentElement.classList.remove(className);
        document.documentElement.scrollTop = -parseFloat(
          document.getElementsByTagName("body")[0].style.top.replace("px", "")
        );
        this.resultPopupClickawayLock = true;
      }
    },
  },

  computed: {
    ...mapGetters(["remoteConfig", "currentUser", "currentTags"]),
    loaded() {
      return this.remoteConfig && this.texts && this.quest && this.auth_hash;
    },
    valid() {
      return (
        this.validationStatus === "ok" &&
        this.points &&
        this.points > 0 &&
        this.points <= this.transferPoints &&
        this.comment &&
        !this.loading &&
        (!this.texts.reason || this.reason)
      );
    },
    filteredCharities() {
      if (!this.currentTags) return [];
      let isRussia =
        this.currentTags &&
        this.currentTags.find((tag) => tag.tag === "Location Russia");
      return this.texts.charities.options.filter(
        (v) => !(isRussia && "noRussia" in v && v.noRussia)
      );
    },
  },
  methods: {
    onInput() {
      let cachedEmail = this.email;
      this.validationStatus = "none";
      setTimeout(() => {
        if (this.email === cachedEmail) {
          this.checkEmail();
        }
      }, 500);
    },
    checkEmail() {
      if (!this.auth_hash || !this.email) {
        return;
      }
      this.$jsonp(
        `https://luxoft.sailplay.com/js-api/1954/users/search/?auth_hash=${
          this.auth_hash
        }&email=${encodeURIComponent(this.email)}`
      ).then((data) => {
        this.validationStatus =
          this.currentUser.email === this.email ? "error" : data && data.status;
        if (this.validationStatus === "ok") {
          this.userId = data.id;
        }
      });
    },
    closePopups() {},
    transfer() {
      if (
        !this.auth_hash ||
        !this.email ||
        !this.points ||
        !this.valid ||
        !this.userId
      ) {
        return;
      }
      this.loading = true;
      let comment = this.reason
        ? `${this.reason} ${this.comment}`
        : this.comment;
      this.$jsonp(
        `https://luxoft.sailplay.com/js-api/1954/users/points/transfer?action_id=${this.quest.id}&auth_hash=${this.auth_hash}&points=${this.points}&to_user_id=${this.userId}&comment_to=${comment}`
      ).then((data) => {
        this.open = false;
        this.email = "";
        this.points = "";
        this.userId = "";
        this.reason = "";
        this.comment = "";
        this.loading = false;
        this.validationStatus = "none";

        if (data && data.status === "ok") {
          this.$store
            .dispatch("updateP2PQuest")
            .then(() => (this.resultPopup = "success"));
        } else if (
          data &&
          data.status === "error" &&
          data.message ===
            "Exceeded the limit by sum for points_transfer:per_user point transfer"
        ) {
          this.resultPopup = "limit";
        } else {
          this.resultPopup = "error";
        }
      });
    },
    quarterlySave() {
      this.loading = true;
      let add = this.texts.charities.options
        .filter((option) => option.text == this.quarterlyCharity)
        .map((option) => option && option.text);
      let remove = this.texts.charities.options
        .filter((option) => option.text != this.quarterlyCharity)
        .map((option) => option.text);
      this.$store
        .dispatch("changeTags", {
          add: add,
          remove: remove,
          auth_hash: this.auth_hash,
        })
        .then(() => {
          this.$store
            .dispatch("changeTags", {
              add: add,
              remove: remove,
            })
            .then(() => {
              this.loading = false;
              this.open = false;
              this.tab = "default";
              this.resultPopup = "successQuarterly";
              this.$store.dispatch("fetchTags");
            });
        });
    },
  },
};
</script>